
import { Component, Vue, Watch } from 'vue-property-decorator'
import * as notice from '@/api/notice'
import { debounce } from '@/utils/util'
import editor from '@/components/editor/index.vue'
@Component({
  components: {
    editor
  }
})
export default class ListsDetail extends Vue {
  /** S Data **/

  identity: number | null = null; // 当前编辑用户的身份ID

  setMealData: any = [];

  // 添加通知表单数据
  form: any = {
    subject: '', // 名称
    state: 1, // 状态
    content: '', // 内容
    url: '' // 链接
  };
  showError=false
  // 表单校验
  rules = {
    subject: [{ required: true, message: '请输入通知名称', trigger: 'blur' }],
    content: [
      { required: true, message: '请输入内容', trigger: 'blur' }
    ],
  };

  /** E Data **/

  /** S Methods **/
  // 点击表单提交
  onSubmit(formName: string) {
    // 验证表单格式是否正确

    const refs = this.$refs[formName] as HTMLFormElement
    console.log(this.form.content)
   
    refs.validate((valid: boolean): any => {
      if (!valid) return
      const loading = this.$loading({ text: "保存中" });
      if (!this.identity) {
        this.handlenoticeAdd(loading)
      } else {
        this.handlenoticeEdit(loading)
      }
    })
  }

  // 添加通知
  async handlenoticeAdd(loading: any): Promise<void> {
    try {
      this.form.content=this.form.content.replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
      await notice.apiNoticeAdd({ ...this.form })
      loading.close()
      setTimeout(() => this.$router.go(-1), 500)

    } catch (err) {
      loading.close();
    }

  }

  // 编辑通知
  async handlenoticeEdit(loading: any): Promise<void> {
    try {
     this.form.content=this.form.content.replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
      await notice.apiNoticeEdit({ ...this.form, id: this.identity })
      loading.close()
      setTimeout(() => this.$router.go(-1), 500)

    } catch (err) {
      loading.close();
    }
  }

  // 获取详情
  async getnoticeDetailFunc(): Promise<void> {
    const res: any = await notice.apiNoticeDetail({
      id: this.identity as number
    })
    Object.keys(res).map((key) => {
      this.$set(this.form, key, res[key])
    })
    console.log(res,this.form)
  }

  /** E Methods **/

  /** S Life Cycle **/
  created() {
    const query: any = this.$route.query

    // 编辑模式：初始化数据
    this.identity = +query.id
    if (+query.id) {
      this.getnoticeDetailFunc()
    }
    this.onSubmit = debounce(this.onSubmit, 100)
  }
  /** E Life Cycle **/
}
